import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { ConvenioService } from '../../../../../providers/convenio-service';
import { AlertService } from '../../../../../providers/alert-service';
import { MenuService } from '../../../../../providers/menu-service';

import { ModulosController } from '../../../modulos-controller';
import { UsuarioService } from '../../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../../providers/gestao-pca-service';

@Component({
  selector: 'page-relatorio-auditoria-cge',
  templateUrl: 'relatorio-auditoria-cge.html',
  providers: [
    ConvenioService
  ]
})
export class RelatorioAuditoriaCGEPage extends ModulosController {
  listaDados: any;
  loading: boolean = true;
  submetendoNoCertificado: boolean = false;
  idSecaoPagina: string = "2002";

  order: string = 'nrProcesso';
  reverse: boolean = true;

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public navParams: NavParams,
    public convenioService: ConvenioService,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.carregarDados();
    this.setModuloId(6);
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = false;
      this.order = "-" + value;
    } else {
      this.reverse = true;
      this.order = value;
    }
  }

  formatarPorcentagem(valor) {
    return valor.toString().replace('.', ',') + "%";
  }

  carregarDados() {
    this.convenioService.obterRelatoriosDeAuditoria().subscribe(data => {
      this.listaDados = data;
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });
  }

  baixarArquivo(idArquivo) {
    this.loading = true;
    this.convenioService.downloadArquivoRelatoriosDeAuditoria(idArquivo);
    this.loading = false;
  }

  voltar() {
    this.menuService.redirecionarPagina(this.convenioService.obterIdPaginaConvenio());
  }

  // baixarRelatorioCompleto() {
  //   this.convenioService.obterArquivoRelatorioAuditoria();
  // }

  capitalize(str) {
    let retorno = "";

    if (str) {
      retorno = str.charAt(0).toUpperCase() + str.slice(1);
    }

    return retorno;
  }

  
  salvarComentario() {
    if (this.listaDados) {
      var jsonSubmeter = {
        "idModuloAnalise": this.listaDados.idModuloAnalise,
        "resultado": this.capitalize(this.listaDados.resultado)
      }

      this.convenioService.salvarRelatoriosDeAuditoria(jsonSubmeter, this.idSecaoPagina).subscribe(data => {
        this.alertService.mostraAlerta("", "Salvo com sucesso.");
        this.voltar();
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
      });
    }
  }

  submeterNoCertificado() {
    if (this.listaDados.resultado.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.resultado == null || this.listaDados.resultado == undefined || !this.listaDados.resultado) {
      this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
    } else {
      if (this.listaDados) {

        var jsonSubmeter = {
          "idModuloAnalise": this.listaDados.idModuloAnalise,
          "resultado": this.capitalize(this.listaDados.resultado)
        }

        this.convenioService.submeterRelatoriosDeAuditoria(jsonSubmeter, this.idSecaoPagina).subscribe(data => {
          this.alertService.mostraAlerta("", "Submetido com sucesso.");
          this.voltar();
        }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/convenios/convenio-analise/relatorio-auditoria-cge/relatorio-auditoria-cge.ts